<template>
  <div class="tabs">
    <button v-for="tab in tabs" :key="tab.value" :class="['tab-btn', { active: modelValue === tab.value }]" @click="$emit('update:modelValue', tab.value)" type="button">
      {{ tab.label }}
    </button>
  </div>
  <div class="tab-content">
    <slot :active="modelValue" />
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      required: true // [{ label, value }]
    }
  }
};
</script>

<style scoped>
.tabs {
  display: flex;
  margin-bottom: var(--padding-modal);
}
.tab-btn {
  flex: 1;
  padding: var(--padding-modal);
  background: none;
  border: none;
  cursor: pointer;
  border: 0;
  border-radius: 0;
  border-bottom: 2px solid transparent;
  transition:
    border-color 0.2s,
    color 0.2s;
}
.tab-btn.active {
  border-bottom: 2px solid var(--color-primary);
}
</style>
